export const GET_INVENTORY_STORAGE_LIST_REQUEST = 'GET_INVENTORY_STORAGE_LIST_REQUEST'
export const GET_INVENTORY_STORAGE_LIST_FAIL = 'GET_INVENTORY_STORAGE_LIST_FAIL'
export const GET_INVENTORY_STORAGE_LIST_SUCCESS = 'GET_INVENTORY_STORAGE_LIST_SUCCESS'

export const RESOLVE_INVENTORY_STORAGE_REQUEST = 'RESOLVE_INVENTORY_STORAGE_REQUEST'
export const RESOLVE_INVENTORY_STORAGE_FAIL = 'RESOLVE_INVENTORY_STORAGE_FAIL'
export const RESOLVE_INVENTORY_STORAGE_SUCCESS = 'RESOLVE_INVENTORY_STORAGE_SUCCESS'

export const CLAIM_INVENTORY_STORAGE_REQUEST = 'CLAIM_INVENTORY_STORAGE_REQUEST'
export const CLAIM_INVENTORY_STORAGE_FAIL = 'CLAIM_INVENTORY_STORAGE_FAIL'
export const CLAIM_INVENTORY_STORAGE_SUCCESS = 'CLAIM_INVENTORY_STORAGE_SUCCESS'

export const RESET_INVENTORY_STORAGE = 'RESET_INVENTORY_STORAGE'

export const UPDATE_INVENTORY_STORAGE_STATUS_FILTER = 'UPDATE_INVENTORY_STORAGE_STATUS_FILTER'

export const INVENTORY_STORAGE_LIST_SET_PAGINATION = 'INVENTORY_STORAGE_LIST_SET_PAGINATION'
